import { type Module } from 'vuex';

import { store } from '@/store';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { type IApplicationState } from './types';

const APPLICATION_MODULE = 'application';

const applicationModuleInstance: Module<IApplicationState, unknown> = {
    namespaced: true,
    state: {
        allowNavigationSet: new Set<string>(),
        currentBriefId: undefined,
        emailPreviewText: false,
        directoryAssetExpansion: new Map(),
        directoryCompanyExpansion: new Map(),
        meetingListView: new Map(),
        partnerStatus: undefined,
        recentAgreementBoardId: new Map(),
        recentAllianceBoardId: new Map(),
        recentObligationBoardId: new Map(),
        recentCompanyBoardId: new Map(),
        recentLeadBoardId: new Map(),
        recentMeetingBoardId: new Map(),
        recentViewedBriefsIds: new Map(),
        recentViewedCampaignsIds: new Map(),
        recentViewedCompaniesIds: new Map(),
        recentViewedLeadsIds: new Map(),
        settingsExpansion: new Map(),
        viewedMaxNb: 5
    },
    getters,
    actions,
    mutations
};

store.registerModule(APPLICATION_MODULE, applicationModuleInstance);

export { APPLICATION_MODULE };
